// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1__f2a0113b9c840d969899","cls2":"mentions_milestone_ping-cls2__fd74a0e633711956ba9e mentions_milestone_ping-cls1__f2a0113b9c840d969899"};